import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BaseLogin = _resolveComponent("BaseLogin");
  return _openBlock(), _createBlock(_component_BaseLogin, {
    title: $options.loginTitle,
    fields: $data.loginFields,
    "submit-text": "登录",
    "background-key": "loginBkImg",
    "is-admin": false,
    loading: $data.isLoading,
    onSubmit: $options.handleLogin
  }, null, 8, ["title", "fields", "loading", "onSubmit"]);
}